export default __webpack_public_path__ + "static/media/ahmad-tea.403c353e.png";